import { Reducer } from 'redux'
import { Epic } from 'redux-observable'

import { createFeatureSelector, createSelector } from 'modules/store'

import * as authActions from './auth.actions'
import authEpic from './auth.epic'
import * as fromAuth from './auth.reducer'

// tslint:disable-next-line:no-empty-interface
export interface AuthState extends fromAuth.State {}

export const STORE_ID = 'auth'

export const reducers: Reducer<AuthState> = fromAuth.reducer

export const epics: Array<Epic<any, any, any>> = [authEpic]

export const actions = {
  ...authActions,
}

// module state selector
export const selectAuthState = createFeatureSelector<AuthState>(STORE_ID)

// Selectors
export const getLoggedIn = createSelector(selectAuthState, fromAuth.getLoggedIn)
export const getIsLoggingOut = createSelector(selectAuthState, fromAuth.getIsLoggingOut)
export const getIsLoggingIn = createSelector(selectAuthState, fromAuth.getIsLoggingIn)
export const getUser = createSelector(selectAuthState, fromAuth.getUser)
export const getPrivileges = createSelector(selectAuthState, fromAuth.getPrivileges)
export const getLocaleString = createSelector(selectAuthState, fromAuth.getLocaleString)



// WEBPACK FOOTER //
// ./src/app/auth/store/index.ts